import React, { FC } from 'react';

import { Player, UpdateStatus } from '../../../../database.schema';
import { Button } from '../../common-styles/common-styles';
import { useTournamentTeamsMutation } from '../../../api/create-teams';

type UpdateButtonProps = {
  selectedTournamentIndex: number;
  team1Name: string;
  team1: Array<Player>;
  team2Name: string;
  team2: Array<Player>;
  setUpdateStatus: (updateStatus: UpdateStatus) => void;
  onSuccess: () => void;
  disabled: boolean;
};

export const UpdateButton: FC<UpdateButtonProps> = ({ selectedTournamentIndex, team1Name, team1, team2Name, team2, disabled, setUpdateStatus, onSuccess }) => {
  const mutation = useTournamentTeamsMutation();
  const saveTeams = () => {
    const dataToSave = { selectedTournamentIndex, team1Name, team1, team2Name, team2 };
    if (dataToSave) {
      mutation.mutate(
        { ...dataToSave },
        {
          onSuccess: (data) => {
            onSuccess();
          },
          onError: (error) => {
            setUpdateStatus({ success: false, error: true });
            console.log('<><><>ERROR<><><><', error);
          },
        },
      );
    }
  };
  return (
    <Button data-testid="save-button" onClick={() => saveTeams()} disabled={disabled}>
      Save
    </Button>
  );
};
